module.exports = __webpack_public_path__ + "img/no.ed7007a8.svg";